type LogoProps = {
  size?: number;
  variant?: "dark" | "light";
};

/**
 * Logotipo institucional "SP" (Pomilio & Asociados Seguros).
 * Doble óvalo concéntrico con "SP" en el centro. Reconstruido en SVG vectorial.
 *
 * - variant="dark": sobre fondos claros — óvalos navy + anillo blanco + SP blanco.
 * - variant="light": sobre fondos oscuros — óvalos blancos + anillo navy + SP navy.
 */
export function Logo({ size = 36, variant = "dark" }: LogoProps) {
  const isLight = variant === "light";
  const outer = isLight ? "#ffffff" : "#1e2871";
  const ring = isLight ? "#141d57" : "#ffffff";
  const inner = isLight ? "#ffffff" : "#1e2871";
  const letters = isLight ? "#141d57" : "#ffffff";
  const width = size * 1.6;
  const height = size;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 160 100"
      width={width}
      height={height}
      aria-hidden="true"
      role="img"
    >
      <ellipse cx="80" cy="50" rx="76" ry="46" fill={outer} />
      <ellipse cx="80" cy="50" rx="70" ry="40" fill={ring} />
      <ellipse cx="80" cy="50" rx="64" ry="34" fill={inner} />
      <text
        x="80"
        y="68"
        fill={letters}
        textAnchor="middle"
        fontFamily="'Plus Jakarta Sans', Inter, system-ui, sans-serif"
        fontWeight="800"
        fontSize="46"
        letterSpacing="-1"
      >
        SP
      </text>
    </svg>
  );
}
